import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { TextEditor } from 'shared-components/components/TextEditor';
import demoContent from 'shared-components/components/TipTap/tiptap-templates/simple/data/content.json';

const TextEditorShowcase = () => {
  /**
   * NOTE this is a hardcoded version group ID for testing
   */
  const versionGroupId = '1';

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Text Editor
      </Typography>

      <Paper elevation={1} sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary" paragraph>
          Version Group ID: {versionGroupId}
        </Typography>
        <TextEditor visibleActions="all" initialContent={demoContent} />
      </Paper>
    </Box>
  );
};

export default TextEditorShowcase;
